import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Social from "./Social";
import g from "../utils/globals";

class ShareButtons extends Component {
  getSocial = () => {
    if (this.props.attributes && this.props.attributes.social) {
      return this.props.attributes.social;
    }
    return null;
  };

  render = () => {
    const social = this.getSocial();
    if (!social.id) return null;

    const attrs = this.props.attrs;

    return (
      <Fragment>
        {social.sharePosition.indexOf("top") < 0 ? this.props.children : null}
        <div
          id={`share-${social.id}`}
          className={`share ${social.shareClasses.join(" ")} ${social.sharePosition.replace(" ", "-")}`}
          data-media={attrs.src}
        >
          <div className="share-actions _share-actions">
            <ul className="socialLinks _share">
              {g.sharingMethods.map((x, i) => (
                <li key={i}>
                  <Social social={x} media={attrs.src} url={window.location.href} analytics={false} />
                </li>
              ))}
            </ul>
          </div>
        </div>
        {social.sharePosition.indexOf("top") > -1 ? this.props.children : null}
      </Fragment>
    );
  };
}

ShareButtons.defaultProps = {
  attrs: {},
};

ShareButtons.propTypes = {
  attrs: PropTypes.shape({}),
};

export default ShareButtons;
